export const pageSizeOptions = [10, 20, 50, 100].map((o) => ({
  id: o.toString(),
  name: o,
}));
